import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import AchievementRateListItem from 'components/presenters/campaign/achievement/AchivementRateListItem';

import uniThumbsUp from 'images/character/uni_thumbs_up-239x300.png';
import arrowRight from 'images/icon/arrow-right-121212-15x27.png'

export default function AchievementRateList({userInfo, memberAchievementRateList}) {
    return (
        <>
        {
            memberAchievementRateList.length !== 0 ? (
                <>
                    <AchievementRateListBlock>
                        {memberAchievementRateList.map((achievementRateItem, index) => 
                            <AchievementRateListItem key={`campaign_achievement_rate_user_no_${achievementRateItem['user_no']}`} userInfo={userInfo} achievementRateItem={achievementRateItem} index={index}/>
                        )}
                    </AchievementRateListBlock>
                    <CertificationBtnBlock>
                        <CertificationBtn to="/task/list">
                            <span>인증하러가기</span>
                            <ArrowIconBlock>
                                <ArrowIcon src={arrowRight} />
                            </ArrowIconBlock>
                        </CertificationBtn>
                    </CertificationBtnBlock>
                </>
            ) : (
                <DefaultEmptyMsgBlock>
                    <DefaultEmptyImgBlock>
                        <DefaultEmptyImg src={uniThumbsUp} />
                    </DefaultEmptyImgBlock>
                    <DefaultEmptyMsg>챌린지에 참여하고 함께 뛰어보세요!</DefaultEmptyMsg>
                </DefaultEmptyMsgBlock>
            )
        }
        </>
    )
}

export const AchievementRateListBlock = styled.div`
    position: relative;
    width: 100%;
    padding-bottom: calc(100vw * (60 / 375));
`;

export const DefaultEmptyMsgBlock = styled.div`
    display: flex;
    flex-direction: column;
    justify-constent: flex-start;
    align-items: center;
    height: 100%;
    weight: 100%;
`;

export const DefaultEmptyImgBlock = styled.div`
    width: calc(100vw * (83 / 375));
    height: calc(100vw * (100 / 375));
    margin-top: calc(100vw * (103 / 375));
    margin-bottom: calc(100vw * (17 / 375));
`;

export const DefaultEmptyImg = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export const DefaultEmptyMsg = styled.p`
    width: 100%;
    text-align: center;
    font-size: calc(100vw * (14 / 375));
    font-weight: 500;
    line-height: calc(100vw * (23 / 375));
    color: #7F7F7F;
`;

const CertificationBtnBlock = styled.div`
    position: fixed;
    bottom: 15px;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
`;

const CertificationBtn = styled(Link)`
    font-size: calc(100vw * (14 / 375));
    font-weight: 500;
    line-height: calc(100vw * (23 / 375));
    text-align: center;
    background: #FFCF19;
    box-shadow: 0px 0px 10px 3px #E8E8E8;
    width: calc(100vw * (146 / 375));
    padding: calc(100vw * (14 / 375)) 0;
    border-radius: calc(100vw * (30 / 375));
    display: flex;
    justify-content: center;
    align-items: center;
`;

const ArrowIconBlock = styled.div`
    width: calc(100vw * (7 / 375));
    height: calc(100vw * (13 / 375));
    margin-left: calc(100vw * (9 / 375));
`;

const ArrowIcon = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;